import styled from 'styled-components';
const Container = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export default Container;
